module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_vm._l((_vm.products), function(prod, prodIndex) {
    return [_c('div', {
      staticClass: "col-sm-4 text-center"
    }, [_c('div', {
      staticClass: "img-box"
    }, [_c('div', {
      staticClass: "img-wrap"
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'Product',
          params: {
            id: prodIndex
          }
        }
      }
    }, [_c('img', {
      attrs: {
        "src": 'images/catalog/' + _vm.campaign.short_url + '/' + prod.item_image_default
      }
    })])], 1)]), _vm._v(" "), _c('p', {
      staticClass: "product-title"
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'Product',
          params: {
            id: prodIndex
          }
        }
      }
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(prod.description)
      }
    })])], 1), _vm._v(" "), _c('p', {
      staticClass: "price"
    }, [(_vm.is12x12(prod.item_image_default || '')) ? [_vm._v("\n\t\t\t\t\t\t$ 500.00\n\t\t\t\t\t")] : (_vm.isTree(prod.item_image_default || '')) ? [_vm._v("\n\t\t\t\t\t\t$ 1500.00\n\t\t\t\t\t")] : (_vm.isNook(prod.item_image_default || '')) ? [_vm._v("\n\t\t\t\t\t\t$ 5000.00\n\t\t\t\t\t")] : _vm._e()], 2)])]
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-edff5e22","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shop/Catalog.vue
// module id = ADAq
// module chunks = 1